import { useState } from "react";
import { Pencil, History } from "lucide-react";
import CorrectionsDialog from "./CorrectionsDialog";
import { useI18n } from "../i18n/I18nContext";

export default function RecordActions({ record, canEdit, onEdit, testid }) {
  const { t } = useI18n();
  const [hist, setHist] = useState(false);
  const n = record.corrections?.length || 0;
  return (
    <div className="flex items-center gap-2 justify-end">
      {n > 0 && (
        <button onClick={() => setHist(true)} data-testid={`corrections-${testid}`}
          className="text-xs font-semibold text-[#B06000] bg-[#FEF7E0] border border-[#FDE293] rounded-full px-2 py-0.5 inline-flex items-center gap-1">
          <History size={12} /> {t("corrected")} {n}
        </button>
      )}
      {canEdit && (
        <button onClick={() => onEdit(record)} data-testid={`edit-${testid}`} className="text-[#1A73E8]" aria-label={t("edit")}>
          <Pencil size={15} />
        </button>
      )}
      <CorrectionsDialog record={record} open={hist} onOpenChange={setHist} />
    </div>
  );
}
